import { IClubCommentListItem, IPostDataResponse, IResourceCommentSubListItem, IStoryListDataResponse } from '@/api'
import { atom, useAtom } from 'jotai'

export const currentNovelCommentAtom = atom<IClubCommentListItem | undefined>(undefined)
currentNovelCommentAtom.debugLabel = 'currentNovelCommentAtom'
export const useCurrentNovelCommentAtom = () => {
  const [currentNovelComment, setcurrentNovelComment] = useAtom(currentNovelCommentAtom)
  return {
    currentNovelComment,
    setcurrentNovelComment,
  }
}

export const currentNovelSubCommentAtom = atom<IResourceCommentSubListItem | undefined>(undefined)
currentNovelSubCommentAtom.debugLabel = 'currentNovelSubCommentAtom'
export const useCurrentNovelSubCommentAtom = () => {
  const [currentNovelSubComment, setCurrentNovelSubComment] = useAtom(currentNovelSubCommentAtom)
  return {
    currentNovelSubComment,
    setCurrentNovelSubComment,
  }
}

export interface INovelCommentUpdateFnAtom {
  mainCommentUpdateFn?: (content: string, picUrls: string[]) => Promise<boolean>
  subCommentUpdateFn?: (content: string, picUrls: string[]) => Promise<boolean>
}
export const novelCommentUpdateFnAtom = atom<INovelCommentUpdateFnAtom>({})
novelCommentUpdateFnAtom.debugLabel = 'novelCommentUpdateFnAtom'
export const useNovelCommentUpdateFnAtom = () => {
  const [novelCommentUpdateFn, setNovelCommentUpdateFn] = useAtom(novelCommentUpdateFnAtom)

  return {
    novelCommentUpdateFn,
    setNovelCommentUpdateFn,
  }
}

export const contentInfoAtom = atom<{ code?: number; data?: IStoryListDataResponse | IPostDataResponse }>({})
contentInfoAtom.debugLabel = 'contentInfoAtom'
export const useContentInfoAtom = () => {
  const [contentInfo, setContentInfo] = useAtom(contentInfoAtom)

  return {
    contentInfo,
    setContentInfo,
  }
}
